import styled from "styled-components";
import LocationBlock from "../Components/BloqueUbicacion";

const StyledSection = styled.section`
    width: 100%;
    padding: 100px 30px;
    background: linear-gradient(135deg, #ff5733, #c70039);
    box-sizing: border-box;
`;

const StyledContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    align-items: flex-start;
`;

const StyledInfoSection = styled.div`
    flex: 1;
    min-width: 350px;
    padding: 30px;
    background: #fff3e6;
    border-radius: 20px;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
`;

const StyledFormSection = styled.div`
    flex: 1;
    min-width: 350px;
    padding: 30px;
    background: #fff3e6;
    border-radius: 20px;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
`;

const StyledHeading = styled.h1`
    font-size: 40px;
    color: #900c3f;
    text-align: center;
    margin-bottom: 50px;
    font-weight: normal;
`;

const StyledSectionHeading = styled.h2`
    font-size: 32px;
    color: #900c3f;
    margin-bottom: 25px;
    text-align: center;
`;

const StyledInfoText = styled.p`
    font-size: 20px;
    color: #581845;
    margin-bottom: 20px;
    text-align: center;
`;

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const StyledInput = styled.input`
  padding: 16px;
  border: 1px solid #bdc3c7;
  border-radius: 8px;
  font-size: 18px;
  transition: border-color 0.3s;

  &:focus {
    border-color: #900c3f;
    outline: none;
  }
`;

const StyledTextarea = styled.textarea`
  padding: 16px;
  border: 1px solid #bdc3c7;
  border-radius: 8px;
  font-size: 18px;
  resize: vertical;
  min-height: 180px;
  transition: border-color 0.3s;

  &:focus {
    border-color: #900c3f;
    outline: none;
  }
`;

const StyledButton = styled.button`
  padding: 16px;
  background-color: #900c3f;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff5733;
  }
`;

const Contact = () => {
  return (
    <StyledSection>
      <StyledHeading>Únete a Vortex 2</StyledHeading>
      <StyledContainer>
        <StyledInfoSection>
          <StyledSectionHeading>Detalles de Contacto</StyledSectionHeading>
          <StyledInfoText>
            <strong>Teléfono :</strong> +34 123 456 789
          </StyledInfoText>
          <StyledInfoText>
            <strong>Email :</strong> contacto@vortex2.com
          </StyledInfoText>
          <StyledInfoText>
            <strong>Dirección :</strong> Calle Imaginaria, 123, Madrid, España
          </StyledInfoText>
        </StyledInfoSection>
        <StyledFormSection>
          <StyledSectionHeading>Envíanos un Mensaje</StyledSectionHeading>
          <StyledForm action="gracias/index.php" method="post">
            <StyledInput type="text" name="name" placeholder="Tu nombre" required />
            <StyledInput type="email" name="email" placeholder="Tu email" required />
            <StyledInput type="text" name="subject" placeholder="Asunto" required />
            <StyledTextarea name="message" placeholder="Escribe tu mensaje aquí..." required />
            <StyledButton type="submit">Enviar Mensaje</StyledButton>
          </StyledForm>
        </StyledFormSection>
      </StyledContainer>
      <div style={{ marginTop: "50px" }}>

      </div>
    </StyledSection>
  );
};

export default Contact;